import React from 'react';
import _ from 'lodash';

import Avatar from 'components/Avatar';
import BookingStatus from 'components/BookingStatus';
import {formatDate} from 'utils/datetime';

import rightStrike from './assets/tail-right.svg';
import './styles.css';

const BookingOption = ({
  object: {
    primaryTenant,
    secondaryTenant,
    period: {startDate, endDate},
    status,
    room
  }
}) => (
  <div className="BookingOption">
    <div className="avatarAndNameContainer">
      <div className="avatarsContainer">
        <Avatar
          className="avatar"
          initials={primaryTenant.initials}
          url={
            primaryTenant.internalAvatarCropped || primaryTenant.avatarCropped
          }
        />
        {secondaryTenant && (
          <Avatar
            className="avatar"
            initials={secondaryTenant.initials}
            url={
              secondaryTenant.internalAvatarCropped ||
              secondaryTenant.avatarCropped
            }
          />
        )}
      </div>
      <div className="fullNamesContainer">
        <div>{primaryTenant.fullName}</div>
        {secondaryTenant && (
          <div className="secondaryTenant">{secondaryTenant.fullName}</div>
        )}
      </div>
    </div>

    <div className="periodAndStatusContainer">
      <div className="roomAndPeriodContainer">
        <div className="roomContainer">
          Last Room {_.get(room, 'roomNumber')}
        </div>
        <div className="bookingPeriodContainer">
          <div>{formatDate(startDate)}</div>
          <img src={rightStrike} alt="Right strike" />
          <div>{formatDate(endDate)}</div>
        </div>
      </div>
      <div className="bookingStatusContainer">
        <BookingStatus status={status} />
      </div>
    </div>
  </div>
);

export default BookingOption;
